import React from 'react';

const Legend = (props) => {
  const { Text, id, color, iconClass } = props;
  return (
    <div
      className="-cursor-pointer"
      onClick={() => props.onLegendClick(Text, id)}
    >
      <i style={{ color }} className={iconClass}></i>{' '}
      <span id={id}>{Text}</span>
    </div>
  );
};
export default Legend;
